// Sprint 65 — Deal Baazar countdown widget.
// Ticks every second, calls onExpire once when it hits zero.

import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { fmtRemaining, msRemaining } from "@/lib/dealPricing";

export default function DealCountdown({ campaign, onExpire, className = "", size = "md" }) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!campaign?.end_date) return;
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign?.end_date]);

  const ms = msRemaining(campaign);
  useEffect(() => {
    if (ms === 0 && typeof onExpire === "function") onExpire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ms === 0]);

  if (ms == null) return null;

  const label = fmtRemaining(ms);
  const cls =
    size === "sm" ? "text-[10px] px-1.5 py-0.5 gap-1"
    : size === "lg" ? "text-sm px-3 py-1.5 gap-1.5"
    : "text-[11px] px-2 py-1 gap-1";

  return (
    <span
      className={`inline-flex items-center rounded-full bg-black/85 text-white font-mono font-bold tabular-nums shadow ${cls} ${className}`}
      data-testid={`deal-countdown-${campaign?.id || campaign?.slug || ""}`}
    >
      <Timer className="w-3 h-3" />
      <span className="uppercase opacity-75 mr-0.5" style={{ fontFamily: "inherit" }}>Ends in</span>
      <span>{label}</span>
    </span>
  );
}
